import {closeModal} from "./Modules/Modals.js"
import Echo from 'laravel-echo'
import Pusher from 'pusher-js';

import axios from 'axios';
window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';




$('body').on('click','.modal button.btn-close',function (e) {
    let modal = $(this).parent().parent().parent().parent();
    let modalID = modal.attr('id');
    closeModal(modalID);
});

let serviceworker = '/service-worker'
if ('serviceWorker' in navigator) {
    navigator.serviceWorker
        .register(serviceworker, { scope: '/' })
        .then(function (reg) {
            let sw = reg.installing || reg.waiting || reg.active;

            if (sw) {
                window._activeServiceWorker = sw;

                sw.addEventListener('statechange', function (e) {
                    console.log('sw statechange : ', e.target.state);
                    if (e.target.state === 'activated') {
                        console.log('Just now activated. now we can subscribe for push notification');
                    }
                });
            }
        })
        .catch(function (err) {
            console.error('Service Worker registration failed:', err);
        });
}


window.Pusher = Pusher;

const realtimeConfig = window.realtimeConfig ?? {};

// A self-hosted Pusher-protocol server (Reverb in the local Docker stack)
// replaces the hosted cluster when a host is configured.
const selfHostedSocket = realtimeConfig.host
    ? {
        wsHost: realtimeConfig.host,
        wsPort: realtimeConfig.port,
        wssPort: realtimeConfig.port,
        forceTLS: realtimeConfig.scheme === 'https',
        enabledTransports: ['ws', 'wss'],
    }
    : {};

if (realtimeConfig.key && realtimeConfig.cluster) {
    window.Echo = new Echo({
        broadcaster: 'pusher',
        key: realtimeConfig.key,
        cluster: realtimeConfig.cluster,
        encrypted: true,
        ...selfHostedSocket,
        authorizer: (channel, options) => {
            return {
                authorize: (socketId, callback) => {
                    axios.post('/api/broadcasting/auth', {
                        socket_id: socketId,
                        channel_name: channel.name,
                        shop_id: `${localStorage.getItem('shop_id')}`,
                        user_id: `${localStorage.getItem('uid')}`,
                        token: `${localStorage.getItem('token')}`,
                    }, {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem('token')}`,
                            'X-token': `Bearer ${localStorage.getItem('token')}`,
                        }
                    })
                    .then(response => {
                        callback(null, response.data);
                    })
                    .catch(error => {
                        callback(error);
                    });
                }
            };
        },
        auth: {
            params: {
                token: `${localStorage.getItem('token')}`
            },
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
                'X-token': `Bearer ${localStorage.getItem('token')}`,
            }
        }
    });
}
